import React from 'react'
import { Button, Modal, ModalTitle, Row, Col } from 'react-bootstrap'
import {format, parseISO} from 'date-fns'
import {eventTypeLabel} from "./EventTypeLabels";

const EventDetailDialog = ({ event, onClose }) => {
    if (!event) return null

    // Parse JSON details if present
    const parseDetails = (detailsStr) => {
        if (!detailsStr) return null
        try {
            return JSON.parse(detailsStr)
        } catch (e) {
            return null
        }
    }

    const details = parseDetails(event.details)

    const renderDetailRow = (label, value) => {
        if (!value) return null
        return (
            <Row className="mb-2">
                <Col sm={4}><strong>{label}:</strong></Col>
                <Col sm={8}>{value}</Col>
            </Row>
        )
    }

    const renderChangedFields = (fields) => {
        if (!fields || fields.length === 0) return null
        return (
            <Row className="mb-2">
                <Col sm={4}><strong>Ändrade fält:</strong></Col>
                <Col sm={8}>{fields.join(', ')}</Col>
            </Row>
        )
    }

    const isTransmissionEvent = event.type && event.type.startsWith('REFERRAL_TRANSMISSION')

    const getTransmissionResult = (type) => {
        switch (type) {
            case 'REFERRAL_TRANSMISSION_SUCCESS':
                return { text: 'Lyckad', variant: 'success' }
            case 'REFERRAL_TRANSMISSION_FAILED_CLIENT':
                return { text: 'Misslyckad - Klientfel', variant: 'danger' }
            case 'REFERRAL_TRANSMISSION_FAILED_SERVER':
                return { text: 'Misslyckad - Serverfel', variant: 'danger' }
            case 'REFERRAL_TRANSMISSION_FAILED_REST_CLIENT':
                return { text: 'Misslyckad - Kommunikationsfel', variant: 'danger' }
            default:
                return { text: 'Okänd', variant: 'secondary' }
        }
    }

    return (
        <Modal
            show={true}
            onHide={onClose}
            backdrop="static"
            keyboard={true}
            size="lg"
            className="EventDetailDialog"
        >
            <Modal.Header closeButton>
                <ModalTitle><h3>Händelsedetaljer</h3></ModalTitle>
            </Modal.Header>
            <Modal.Body>
                {/* Basic info */}
                {renderDetailRow('Händelse', eventTypeLabel(event.type))}
                {renderDetailRow('Tid', format(parseISO(event.timestamp), 'yyyy-MM-dd HH:mm:ss'))}
                {renderDetailRow('Användar-ID', event.userId)}
                {event.description && renderDetailRow('Beskrivning', event.description)}
                {event.returnedStatusCode && renderDetailRow('Statuskod', event.returnedStatusCode)}
                {event.errorMessage && (
                    <Row className="mb-2">
                        <Col sm={4}><strong>Felmeddelande:</strong></Col>
                        <Col sm={8} className="text-danger">{event.errorMessage}</Col>
                    </Row>
                )}

                {/* Transmission event specific fields */}
                {isTransmissionEvent && (
                    <>
                        <hr />
                        <h5>Transmissionsdetaljer</h5>
                        <Row className="mb-2">
                            <Col sm={4}><strong>Resultat:</strong></Col>
                            <Col sm={8}>
                                <span className={`text-${getTransmissionResult(event.type).variant}`}>
                                    {getTransmissionResult(event.type).text}
                                </span>
                            </Col>
                        </Row>
                        {renderDetailRow('Avsändare', event.senderOrganizationName)}
                        {renderDetailRow('HSA-id avsändare', event.senderOrganizationHsaId)}
                        {renderDetailRow('Mottagare', event.receiverOrganizationName)}
                        {renderDetailRow('HSA-id mottagare', event.receiverOrganizationHsaId)}
                        {renderDetailRow('Remiss-id', event.referralId)}
                        {renderDetailRow('Korrelations-id', event.returnedCorrelationId)}
                    </>
                )}

                {/* Details from JSON */}
                {details && (
                    <>
                        <hr />
                        <h5>Ytterligare detaljer</h5>
                        {details.targetUserId && renderDetailRow('Berörd användare ID', details.targetUserId)}
                        {details.targetUserEmail && renderDetailRow('Berörd användare e-post', details.targetUserEmail)}
                        {details.targetOrgId && renderDetailRow('Berörd organisation ID', details.targetOrgId)}
                        {details.targetOrgName && renderDetailRow('Berörd organisation', details.targetOrgName)}
                        {details.targetCareUnitId && renderDetailRow('Berörd vårdenhet ID', details.targetCareUnitId)}
                        {details.targetCareUnitName && renderDetailRow('Berörd vårdenhet', details.targetCareUnitName)}
                        {details.targetShopId && renderDetailRow('Berörd optiker ID', details.targetShopId)}
                        {details.targetShopName && renderDetailRow('Berörd optiker', details.targetShopName)}
                        {details.referralId && renderDetailRow('Remiss-ID', details.referralId)}
                        {renderChangedFields(details.changedFields)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onClose}>Stäng</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EventDetailDialog
